export function toMoneyUS(value) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  });
  // Create our number formatter.
  return isNaN(value) ? "" : formatter.format(value);
}
